import { dataFitWidth } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFitWidth = /*#__PURE__*/createIcon(dataFitWidth)
export default IconFitWidth
